import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  quantity: attr(Number),
  quantityDenominator: attr(Number)
});